import { useSelector } from 'react-redux';
import { Switches } from 'store/remoteConfig/types';
import { State } from 'store/types';

export const useConfigSwitch = (key: keyof Switches): boolean => {
  const remoteConfigSwitches = useSelector(
    (state: State) => state.remoteConfig.switches
  );
  return remoteConfigSwitches[key] as boolean;
};
